import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { Range } from './range.model';

export const MATCHED_SUBSTRING_SCHEMA = Object.freeze({
  PATH: '',
  RANGES: List<Range>(),
});
const RECORD = generateSchema(MATCHED_SUBSTRING_SCHEMA);
const KEYS: any = generateKeys(MATCHED_SUBSTRING_SCHEMA);

export class MatchedSubstring extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.RANGES,
        value: this.get(KEYS.RANGES)
          ? this.ranges.map((params) => new Range(params))
          : List<Range>([]),
      },
    ]);

    return selfModel as MatchedSubstring;
  }

  get path(): string {
    return this.get(KEYS.PATH);
  }

  get ranges(): List<Range> {
    return this.get(KEYS.RANGES);
  }
}
